module.exports = __webpack_public_path__ + "static/media/sb.0e550c35.svg";